export const enum GRAY_OPTION {
  'ALL_GRAY_OUT' = 1,
  'CLICKED_GRAY_OUT' = 0,
}

export const enum CLICKABLE_TYPE {
  'ALL_CLICKABLE',
  'ALL_DISABLED',
  'CLICKED_ONCE_TO_DISABLED',
  'CLICKED_ITEM_TO_DISABLED',
}
